import React, { Component } from "react";
import { Helmet } from "react-helmet";
import styles from "./Home.module.scss";
import Header from "../Header/Header";
import Hero from "../Hero/Hero";
import Footer from "../Footer/Footer";
import foire from "../../assets/images/FOIRE.png";
import rbnet from "../../assets/images/reformed-baptist-network-logo.png";
import ProgressBar from "../ProgressBar/ProgressBar";
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from "react-router-dom";
import BaseService from "../../services/BaseService";
import ReactDOM from "react-dom";
import { Parser } from "html-to-react";
import Button from "@material-ui/core/Button";
import GA from "../GA/GA";
import { ServicesService } from "../../services/ServicesService";
import rbs from "../../assets/images/Creation-Covenant-Christ.png";
import creation from "../../assets/images/Creation_26-FB.jpg";
import christmas from "../../assets/images/christmas-carol-2025.png";


class Home extends Component {
  baseService = new BaseService();
  servicesService = new ServicesService();

  state = {
    sideDrawerOpen: false,
    loading: true,
    announcement: "",
    liveStreamDescription: "",
    liveStreamVideo: "",
    services: {}
  };

  drawerToggleClickHandler = () => {
    this.setState((prevState) => {
      return { sideDrawerOpen: !prevState.sideDrawerOpen };
    });
  };

  async componentDidMount() {
    this.setState({ loading: false });

    const result = await this.baseService.get("/home");
    const services = await this.servicesService.getAllService();

    const { announcement, live_stream_description, youtube_video_code } = result[0];
    this.setState({
      announcement,
      liveStreamDescription: live_stream_description,
      liveStreamVideo: youtube_video_code,
      services
    });
    ReactDOM.hydrate(new Parser().parse(this.state.announcement), document.getElementById("announcement"));
  }

  render() {
    return (
      <div className={styles.home}>
        <Helmet>
          <title>Reformed Baptist Church of Riverside</title>
          <link rel="canonical" href="http://www.rbcr.org/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="Reformed Baptist Church of Riverside" />
          <meta property="og:url" content={`http://www.rbcr.org/`} />
          <meta property="og:site_name" content="Reformed Baptist Church of Riverside" />
        </Helmet>
        <Header drawerClickHandler={this.drawerToggleClickHandler} />
        <Hero />
        <div>
          <div className={styles.container}>
             <div className={styles.spotlightGrid}>
              {/* <div className={styles.refGrid_2}>
              <h2 className={styles.videoGrid_title}>Womanly Dominion Mini Conference</h2>
                 <p>Come join us for the Womanly Dominion Mini Conference: More Than A Gentle and Quiet Spirit, with guest speaker Pastor Mark Chanski.</p>
                 <p>Feburary 10, 2024 10:00 AM - 3:00 PM</p>
                 <p>Click <a href="/womens-conference">here</a> for more information and <a href="https://forms.gle/kDbahFi4DSv4akui7" target="_blank">Register today</a></p>
              </div>
              <div className={styles.refGrid_1}>
                <a href="/womens-conference">
                  <img src="https://rbcr-prod.s3.us-west-1.amazonaws.com/uploads/2024/01/05/Screen_Shot_2024_01_05_at_10_42_33_PM_f53d552de9-Screen%20Shot%202024-01-05%20at%2010.42.33%20PM.png" alt="Womanly Dominion Mini Conference" />
                </a>
              </div> */}
               <div className={styles.refGrid_2}>
                 <h2 className={styles.videoGrid_title}>Reformation Night 2026!!</h2>
                 <p>October 31, 2026 5:00pm to 8:00pm</p>
                 <p>It’s autumn and we’re excited to celebrate the Glorious Reformation on Saturday, October 31, from 5 to 8 p.m.</p>
                 <p>Join us as we explore how God used the Reformation to shine his glory by enjoying fun games, creative crafts, and delicious seasonal snacks.</p>
               </div>
               <div className={styles.refGrid_1}>
                 <img src="https://rbcr-prod.s3.us-west-1.amazonaws.com/uploads/2026/10/11/unnamed_9090db59ac-unnamed.png" alt="Reformation Night 2026" />
               </div>
            </div>
            {/*<div className={styles.spotlightGrid}>*/}
            {/*  <div className={styles.rbsGrid_1}>*/}
            {/*      <a href="/vbs">*/}
            {/*        <img src="https://rbcr-prod.s3.us-west-1.amazonaws.com/uploads/2026/07/01/Screenshot_2026_06_26_at_10_14_29_AM_d973518d57-Screenshot%202026-06-26%20at%2010.14.29%E2%80%AFAM.png" alt="VBS" />*/}
            {/*      </a>*/}
            {/*  </div>*/}
            {/*  <div className={styles.rbsGrid_2}>*/}
            {/*    <h2 className={styles.videoGrid_title}>Vacation Bible School 2026</h2>*/}
            {/*    <p>Join us as we explore the epic themes of Pilgrim's Progress and follow Christian on his great journey of faith to the Celestial Kingdom. Through Bible lessons, skits, crafts, and fun activities, your kids will learn that we can only become a part of God's kingdom by faith alone in Jesus alone who is the way, the truth, and the life!</p>*/}
            {/*    <p>To learn more and register, click <a href="/vbs">here</a></p>*/}
            {/*  </div>*/}
            {/*</div>*/}
            {/*<div className={styles.spotlightGrid}>*/}
            {/*  <div className={styles.rbsGrid_1}>*/}
            {/*    <a href="/youth-conference">*/}
            {/*      <img src="https://rbcr-prod.s3.us-west-1.amazonaws.com/uploads/2026/03/17/RBCR_YC_One_Sheet_26_84b57fd090-RBCR_YC_OneSheet_26.jpg" alt="Youth Conference" />*/}
            {/*    </a>*/}
            {/*  </div>*/}
            {/*  <div className={styles.rbsGrid_2}>*/}
            {/*    <h2 className={styles.videoGrid_title}>Youth Conference {new Date().getFullYear()}</h2>*/}
            {/*    <p>Join us June 26-29 for our annual youth conference where we will be discussing the topic of <i>Encountering The Great I AM</i>.</p>*/}
            {/*    <p><a href="/youth-conference">View More</a></p>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className={styles.spotlightGrid}>
              {/*<div className={styles.refGrid_2}>*/}
              {/*  <h2 className={styles.videoGrid_title}>PROFESSOR ANDY MCINTOSH: CREATION, SCIENCE, AND THE BIBLE</h2>*/}
              {/*  <p>We hope you can join us March 28, 2026.</p>*/}
              {/*  <div>*/}
              {/*    <ul style={{ fontSize: "18px"}}>*/}
              {/*      <li>*/}
              {/*        2:00 PM - The Wonder of Feathers and Flight*/}
              {/*      </li>*/}
              {/*      <li>*/}
              {/*        4:00 PM - DNA, Molecules, & People: Who Am I?*/}
              {/*      </li>*/}
              {/*    </ul>*/}
              {/*  </div>*/}
              {/*</div>*/}
              {/*<div className={styles.refGrid_1}>*/}
              {/*  <img src={creation} alt="Creation 2026" />*/}
              {/*</div>*/}
                {/*<div className={styles.rbsGrid_2}>*/}
                {/*    <h2 className={styles.videoGrid_title}>Christmas Carol Service</h2>*/}
                {/*    <p>Come join us for an evening of singing Christmas Carols that point us to the true meaning of Christmas. Afterwards, we'll enjoy some home made soups and desserts. Invite your friends, family, and neighbors.</p>*/}
                {/*    <p>December 21 - 4:30 PM - Soup/Dessert to follow</p>*/}
                {/*</div>*/}
                {/*<div className={styles.grid2}>*/}
                {/*    <img src={christmas} alt="Christmas Carol" />*/}
                {/*</div>*/}
            </div>
          </div>
        </div>
        <div className={styles.welcome}>
          <div className={styles.container}>
            <ScrollAnimation animateIn="fadeInLeft">
              <div className={styles.welcome__content}>
                <p>
                  e’re glad you are here and taking the time to get to know us better.
                  <br></br>Reformed Baptist Church of Riverside is a body of believers desiring to grow in the grace and
                  knowledge of our Lord Jesus Christ. We trust that this website will share a bit of who we are, what we
                  believe, and how you can get involved. So look around. Get a feel for what we believe and where we are
                  going. If you have any questions, please feel free to contact us.
                </p>
              </div>
            </ScrollAnimation>
          </div>
        </div>
        <div className={styles.textureBg}>
          <div className={styles.container}>
            <div className={styles.announcement}>
              <blockquote id="announcement" />
            </div>
          </div>
        </div>
        <div className={styles.container}>
          <ScrollAnimation animateIn="fadeIn">
            <div className={styles.videoGrid}>
              <div className={styles.videoGrid_1}>
                <h2 className={styles.videoGrid_title}>Our Latest Live Stream</h2>
                <hr className={styles.vg_hr} />
                <p className={styles.videoGrid_paragraph}>{this.state.liveStreamDescription}</p>
              </div>
              <div className="embed-responsive embed-responsive-16by9">
                {this.state.liveStreamVideo && (
                  <iframe
                    src={`https://www.youtube.com/embed/${this.state.liveStreamVideo}`}
                    className="embed-responsive-item"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                )}
              </div>
            </div>
            <hr />
            <div className={styles.videoGrid}>
              <div className="embed-responsive embed-responsive-16by9">
                <iframe
                  title="vimeo-player"
                  src="https://player.vimeo.com/video/46077594"
                  className="embed-responsive-item"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
              <div className={styles.videoGrid_2}>
                <h2 className={styles.videoGrid_title}>Who we are</h2>
                <hr className={styles.vg_hr} />
                <p className={styles.videoGrid_paragraph}>
                  Want to learn more about who we are? Then please watch this short video by Pastor Robert Elliott.
                </p>
                <Link to="/about-rbcr/what-we-believe/">
                  <Button variant="contained" size="large" color="primary">
                    Learn more
                  </Button>
                </Link>
              </div>
            </div>
          </ScrollAnimation>
          <ScrollAnimation animateIn="fadeInUp">
            <div className={styles.churchGrid}>
              <div className={styles.outerDiv}>
                <div className={styles.churchGrid_1}>
                  <a href="/sermons" className={styles.sermons_a} rel="noopener noreferrer">
                    <h2 className={styles.churchGrid_title}>Sermons</h2>
                  </a>
                </div>
              </div>
              <div className={styles.outerDiv}>
                <div className={styles.churchGrid_2}>
                  <Link to="/about-rbcr/the-baptist-confession-of-faith-of-1689/" className={styles.sermons_a}>
                    <h2 className={styles.churchGrid_title}>1689 London Baptist Confession</h2>
                  </Link>
                </div>
              </div>
              <div className={styles.outerDiv}>
                <div className={styles.churchGrid_3}>
                  <Link to="/about-rbcr/church-constitution/" className={styles.sermons_a}>
                    <h2 className={styles.churchGrid_title}>Church Constitution</h2>
                  </Link>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>
        <div className={styles.churchService}>
          <div className={styles.container}>
            <div className={styles.timeGrid_1}>
              <ScrollAnimation animateIn="fadeInRight">
                <h3 className={styles.churchService_title}>Come Join Us</h3>
                <hr className={styles.cs_hr} />
              </ScrollAnimation>
            </div>
            <ScrollAnimation animateIn="fadeIn">
              <p className={styles.meetingHeader}>Sunday</p>
              <div className={styles.timeGrid}>
                <div className={styles.timeGrid_1}>
                  <p className={styles.timeCircle}>{this.state.services.spanish}</p>
                  <p className={styles.timeDay}>Spanish Ministry</p>
                </div>
                <div className={styles.timeGrid_1}>
                  <p className={styles.timeCircle}>{this.state.services.sundaySchool}</p>
                  <p className={styles.timeDay}>Sunday School</p>
                </div>
                <div className={styles.timeGrid_1}>
                  <p className={styles.timeCircle}>{this.state.services.morning}</p>
                  <p className={styles.timeDay}>Sunday Worship</p>
                </div>
                <div className={styles.timeGrid_1}>
                  <p className={styles.timeCircle} style={{margin: "5px auto 14px auto"}}>{this.state.services.evening}</p>
                  <p className={styles.timeDay}>Sunday Evening</p>
                  <p className={styles.timeDay} style={{fontStyle: "italic"}}>(No evening service the last Sunday of the month)</p>
                </div>
              </div>
              <p className={styles.meetingHeader}>Wednesday</p>
              <div className={styles.timeGridBottom}>
                <div className={styles.timeGrid_1}>
                  <p className={styles.timeCircle}>7:00pm</p>
                  <p className={styles.timeDay}>Prayer Meeting</p>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </div>
        <div className={styles.spanishMinistry}>
          <div className={styles.container}>
            <div></div>
          </div>
        </div>
        <div className={styles.affiliation}>
          <div className={styles.container}>
            {/*<ScrollAnimation animateIn="zoomIn">*/}
            <div className={styles.affiliationGrid_1}>
              <h2 className={styles.affiliation_title}>Affiliation</h2>
              <hr className={styles.affiliation_hr} />
            </div>
            <div className={styles.affiliationGrid}>
              <div className={styles.affiliationGrid_1}>
                <a href="https://www.firefellowship.org/" target="_blank" rel="noopener noreferrer">
                  <img src={foire} className={styles.foire} alt="fellowship-of-independant-reformed-evangelicals" />
                </a>
              </div>
              <div className={styles.affiliationGrid_1}>
                <a href="https://reformedbaptistnetwork.com/" target="_blank" rel="noopener noreferrer">
                  <img src={rbnet} className={styles.rbnet} alt="reformed-baptist-network" />
                </a>
              </div>
            </div>
            {/*</ScrollAnimation>*/}
          </div>
        </div>
        <div className={styles.visitUs}>
          <div className={styles.container}>
            <ScrollAnimation animateIn="fadeIn">
              <div className={styles.videoGrid}>
                <div className={styles.videoGrid_1}>
                  <iframe
                    title="google-map"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13229.033397118246!2d-117.4417612!3d34.0115789!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3589eb3702595433!2sReformed%20Baptist%20Church%20of%20Riverside!5e0!3m2!1sen!2sus!4v1576124844684!5m2!1sen!2sus"
                    className={styles.map}
                    style={{ border: 0 }}
                    width="600"
                    height="350"
                    frameBorder="0"
                    allowFullScreen={true}
                  ></iframe>
                </div>
                <div className={styles.videoGrid_2}>
                  <div className={styles.videoGrid_titleBlock}>
                    <h2 className={styles.videoGrid_title}>Visit Us</h2>
                    <hr className={styles.vg_hr} />
                  </div>
                  <p className={styles.videoGrid_paragraph}>
                    We'd love to hear from you!
                    <br />
                    <br />
                    Have a question or a comment? <br />
                    <br />
                    We want to hear it! Feel free to call, write, or email us. Or better yet, come join us for one of
                    our Sunday services.
                  </p>
                </div>
              </div>
            </ScrollAnimation>
          </div>
        </div>
        <Footer />
        {this.state.loading && <ProgressBar />}
        <GA title="Reformed Baptist Church of Riverside" />
      </div>
    );
  }
}

export default Home;
